import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { FiBookOpen } from 'react-icons/fi';

const Stories = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newStory, setNewStory] = useState({
    title: '',
    content: '',
    author: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

// Replace your useEffect with:
useEffect(() => {
  // Mock stories data
  setStories([
    {
      id: 1,
      title: "Why I'm Signing This Petition",
      content: "As a Kenyan living abroad, I'm deeply concerned about...",
      author: "James M.",
      created_at: "2023-05-15T10:30:00Z"
    },
    {
      id: 2,
      title: "The Change We Need",
      content: "After years of watching from overseas, it's time to...",
      author: "Sarah W.",
      created_at: "2023-05-16T14:45:00Z"
    }
  ]);
  setLoading(false);
}, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewStory(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await axios.post('/api/stories', newStory);
      setSubmitSuccess(true);
      setNewStory({ title: '', content: '', author: '' });
      // Refresh stories list
      const response = await axios.get('/api/stories');
      setStories(response.data);
    } catch (error) {
      console.error('Error submitting story:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-kenya-red"></div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Stories | Kenyans in Diaspora Petition</title>
      </Helmet>
      
      <h1 className="text-3xl font-bold text-center text-kenya-black mb-8">Stories from Kenyans Abroad</h1>
      
      <div className="grid md:grid-cols-3 gap-8">
        {/* Story Submission Form */}
        <div className="md:col-span-1 bg-kenya-white p-6 rounded-lg shadow-md border border-kenya-green">
          <h2 className="text-xl font-bold mb-4 flex items-center">
            <FiBookOpen className="mr-2" /> Share Your Story
          </h2>
          
          {submitSuccess ? (
            <div className="bg-kenya-green text-white p-4 rounded mb-4">
              Thank you for sharing your story! It will be reviewed before publishing.
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-kenya-black mb-1">Title *</label>
                <input
                  type="text"
                  name="title"
                  value={newStory.title}
                  onChange={handleInputChange}
                  required
                  className="w-full p-2 border border-kenya-black rounded"
                />
              </div>
              
              <div>
                <label className="block text-kenya-black mb-1">Your Name (Optional)</label>
                <input
                  type="text"
                  name="author"
                  value={newStory.author}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-kenya-black rounded"
                />
              </div>
              
              <div>
                <label className="block text-kenya-black mb-1">Your Story *</label>
                <textarea
                  name="content"
                  value={newStory.content}
                  onChange={handleInputChange}
                  required
                  rows="5"
                  className="w-full p-2 border border-kenya-black rounded"
                ></textarea>
              </div>
              
              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full py-2 rounded font-bold ${isSubmitting ? 'bg-gray-400' : 'bg-kenya-red text-white'}`}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Story'}
              </button>
            </form>
          )}
        </div>
        
        {/* Stories List */}
        <div className="md:col-span-2 space-y-6">
          {stories.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-xl">No stories available yet. Be the first to share!</p>
            </div>
          ) : (
            stories.map(story => (
              <article key={story.id} className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-bold mb-2">{story.title}</h3>
                {story.author && (
                  <p className="text-sm text-gray-600 mb-3">By {story.author}</p>
                )}
                <p className="text-gray-800 whitespace-pre-line">{story.content}</p>
                <div className="mt-4 pt-4 border-t border-gray-200 flex justify-between items-center">
                  <span className="text-sm text-gray-500">
                    {new Date(story.created_at).toLocaleDateString()}
                  </span>
                  <button className="text-kenya-red text-sm hover:underline">
                    Report
                  </button>
                </div>
              </article>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Stories;